module.exports = __webpack_public_path__ + "img/step1.5bee0ace.png";